import { render, staticRenderFns } from "./SelectRiskLocationDialog.vue?vue&type=template&id=f20baabe&"
import script from "./SelectRiskLocationDialog.vue?vue&type=script&lang=js&"
export * from "./SelectRiskLocationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports